module.exports = __webpack_public_path__ + "static/media/moderna_pavo.1b110ded.png";